import React, { Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import ATSideNavBar from '../components/layoutComponent/navigation/ATSideNavBar'
import ATNavBar from '../components/layoutComponent/navigation/ATNavBar'
import RoutesConst from './RoutesConst'
import { RootState } from '../store/Store'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

interface RoutesProps {
  index: number
  route: { path: string; main: () => React.ReactElement }
}
const AppRoutes = () => {
  const appConfig = useSelector((state: RootState) => state?.atlas?.appConfig)
  const { t } = useTranslation()
  const getRoute = (props: RoutesProps) => {
    return (
      <Route
        key={props?.index?.toString()}
        path={props?.route?.path}
        element={<props.route.main />}
      />
    )
  }

  return (
    <div style={{ flex: 1 }}>
      <Suspense fallback="">
        <Router>
          <div style={{ display: 'flex' }}>
            <div className="sidemenu" role="navigation" aria-label="side menu">
              <ATSideNavBar />
              <div className="versionInfo">
                <div>v{process.env.REACT_APP_VERSION}</div>
                {appConfig?.legalTermsUrl && (
                  <div className="terms-legal">
                    <Link
                      to={appConfig?.legalTermsUrl}
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('sideMenu.terms_legal')}
                    </Link>
                  </div>
                )}
              </div>
            </div>
            <div className="vh-100" style={{ width: '95vw' }}>
              <div className="main-container" role="main">
                <div
                  className="nav-bar"
                  role="navigation"
                  aria-label="top menu"
                >
                  <ATNavBar />
                </div>
                <div className={`${'route-container'}`}>
                  <Suspense fallback="">
                    <Routes>
                      {RoutesConst.map((route, index) =>
                        getRoute({ index, route }),
                      )}
                    </Routes>
                  </Suspense>
                </div>
              </div>
            </div>
          </div>
        </Router>
      </Suspense>
    </div>
  )
}

export default AppRoutes
